import { render } from "./MessageInput.vue?vue&type=template&id=7c23a2ea&scoped=true&ts=true"
import script from "./MessageInput.vue?vue&type=script&lang=ts"
export * from "./MessageInput.vue?vue&type=script&lang=ts"

import "./MessageInput.vue?vue&type=style&index=0&id=7c23a2ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c23a2ea"]])

export default __exports__